const PLATFORM_BY_POST_TYPE = {
  LIP: 'linkedin',
  XTP: 'twitter',
  IGP: 'instagram',
  IGR: 'instagram',
  IGC: 'instagram',
  IGS: 'instagram',
  TTP: 'tiktok',
  YTP: 'youtube',
  FBP: 'facebook',
  XHS: 'xiaohongshu',
  Lemon8: 'lemon8'
}

export const getReportPlatform = report => {
  // Manual reports may store the creator's account platform in `platform`.
  // Choose the content renderer from the deliverable type and content flags.
  const contentPlatform = PLATFORM_BY_POST_TYPE[report && report.postType]
  if (contentPlatform) return contentPlatform
  if (report && (report.isStory || report.isMultipleContents)) return 'instagram'
  if (report && report.isTikTok) return 'tiktok'
  if (report && report.isYoutube) return 'youtube'
  if (report && report.isFacebook) return 'facebook'
  const platform = String((report && report.platform) || '').trim().toLowerCase()
  if (platform === 'x') return 'twitter'
  return platform || PLATFORM_BY_POST_TYPE[report && report.postType] || ''
}

export const isLinkedInReport = report => getReportPlatform(report) === 'linkedin'
export const isTwitterReport = report => getReportPlatform(report) === 'twitter'

const PROFILE_URL_PREFIXES = {
  instagram: 'https://www.instagram.com/',
  tiktok: 'https://www.tiktok.com/@',
  twitter: 'https://x.com/',
  x: 'https://x.com/',
  facebook: 'https://www.facebook.com/',
  youtube: 'https://www.youtube.com/@',
  xiaohongshu: 'https://www.xiaohongshu.com/user/profile/'
}

export const getReportProfileUrl = (report, fallbackPlatform = '') => {
  if (!report) return '#'
  const owner = report.owner || (report.post_details || {}).owner || {}
  const profile = report.influencer_details || {}
  const explicitUrl = report.profileUrl || report.profile_url || owner.profileUrl || owner.profile_url || owner.profileURL || report.linkedinURL || report.linkedinUrl || report.linkedin_profile_url || ''
  if (/^https?:\/\//i.test(explicitUrl)) return explicitUrl

  const platform = String(report.profilePlatform || report.profile_platform || owner.platform || profile.platform || fallbackPlatform || '').trim().toLowerCase()
  const rawHandle = String(report.profileHandle || report.profile_handle || profile.instagramHandle || owner.username || report.linkedinHandle || report.handle || report.name || report.instagram || '').trim()
  if (!rawHandle) return '#'

  if (platform === 'linkedin') {
    const profileMatch = rawHandle.match(/(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([^/?#]+)/i)
    const profileHandle = (profileMatch ? profileMatch[1] : rawHandle).replace(/^@+/, '').replace(/^\/+|\/+$/g, '')
    return profileHandle ? `https://www.linkedin.com/in/${encodeURIComponent(profileHandle)}` : '#'
  }

  const handle = rawHandle.replace(/^@+/, '').replace(/^\/+|\/+$/g, '')
  return handle && PROFILE_URL_PREFIXES[platform]
    ? PROFILE_URL_PREFIXES[platform] + encodeURIComponent(handle)
    : '#'
}



// WEBPACK FOOTER //
// ./src/utils/reportPlatform.js